import { makeStyles } from "tss-react/mui"
import { StandardDialog } from "../../../../shared/components/dialogs/StandardDialog"
import { CircularProgress, Grid, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { QueryErrorBoundary, QueryFallbackMessage } from "../../../../core/api/components/QueryErrorBoundary"
import { Suspense } from "react"
import { ChangeUserAccountContent } from "./ChangeUserAccountContent"

const useStyles = makeStyles()(() => ({
    content: {
        minHeight: "20rem",
    },
    title: {
        fontSize: "2.25rem",
        fontWeight: 400,
    },
    errorContent: {
        padding: "2rem",
    },
}))

type ChangeUserAccountDialogProps = {
    open: boolean
    onClose: () => void
}

function ChangeUserAccountErrorFallback() {
    const { classes } = useStyles()

    return (
        <LocalizedStrict id="change-user-account-dialog-error-message">
            <QueryFallbackMessage
                slotProps={{
                    contentWrapper: { className: classes.errorContent, justifyContent: "flex-start" },
                    text: { variant: "body1", textAlign: "center" },
                }}
            >
                We couldn't load your accounts. Switching accounts may not be available for this account type.
            </QueryFallbackMessage>
        </LocalizedStrict>
    )
}

export const ChangeUserAccountDialog = ({ open, onClose }: ChangeUserAccountDialogProps) => {
    const { classes } = useStyles()

    return (
        <StandardDialog
            open={open}
            onClose={onClose}
            maxWidthProp="md"
            dialogTitle={
                <LocalizedStrict id="change-user-account-dialog-title">
                    <Typography className={classes.title}>Change user account</Typography>
                </LocalizedStrict>
            }
        >
            <QueryErrorBoundary Fallback={ChangeUserAccountErrorFallback}>
                <Suspense
                    fallback={
                        <Grid container alignItems="center" justifyContent="center" className={classes.content}>
                            <CircularProgress size={70} />
                        </Grid>
                    }
                >
                    <ChangeUserAccountContent onClose={onClose} />
                </Suspense>
            </QueryErrorBoundary>
        </StandardDialog>
    )
}
